import { Avatar, Box, Typography, useTheme } from '@mui/material';
import React from 'react';

const presenters = [
  {
    name: 'Ruszkai Krisztina',
    title:
      'okleveles agrármérnök, törzsállattenyésztő, növénytermesztő, okleveles agrármérnöktanár',
    image: './img/eloadok/RuszkaiKrisztina.jpg',
  },
  {
    name: 'Sipos Mihály',
    title:
      'okleveles agrármérnök, szaporodásbiológus, törzsállattenyésztő, okleveles vadgazdálkodási mérnök, egyetemi oktató',
    image: './img/eloadok/SiposMisi.jpg',
  },
  {
    name: 'Dr. Tóth Tamás Ph.D.',
    title: 'állatorvos, állattenyésztés-tudományok doktora',
    image: './img/eloadok/DrTothTamas.jpg',
  },
  {
    name: 'Dr. Veres Andrea Ph.D.',
    title: 'okleveles agrármérnök, növényorvos, kutató',
    image: './img/eloadok/DrVeresAndrea.jpg',
  },
  {
    name: 'Dr. Tóth Ferenc Ph.D.',
    title: 'okleveles agrármérnök, okleveles agrármérnöktanár',
    image: './img/eloadok/DrTothFerenc.jpg',
  },
];

const Members = () => {
  const theme = useTheme();
  return (
    <Box display='flex' justifyContent='center' flexWrap='wrap' gap={2} p={4}>
      {presenters.map((presenter, index) => (
        <Box
          key={index}
          display='flex'
          flexDirection='column' // 🔹 Elemek egymás alá kerülnek
          alignItems='center' // 🔹 Középre igazítja az Avatar-t és a szöveget is
          textAlign='center' // 🔹 Elemek egymás alá kerülnek
        >
          <Avatar
            src={presenter.image}
            alt={presenter.name}
            sx={{
              width: 100,
              height: 100,
              border: `3px solid ${theme.palette.primary.main}`,
            }}
          />
          <Typography variant='subtitle1' mt={1}>
            {presenter.name}
          </Typography>
          <Typography variant='subtitle2' mt={1} maxWidth={200} mx='auto'>
            {presenter.title}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Members;
